/*    
<summary>
  This functional component "DownloadCSVPopupHOC" provides props to the child component.
  1. State "showDownloadCSVPopup" that manages the show/hide of pop up
  2. Function "downloadCSVPopupToggleHandler" to toggle the show/hide popup state "showDownloadCSVPopup"
  Developer:Aashish Singh, Created Date:02-May-2025
</summary>
<returns>Returns JSX</returns>
*/
import React, { useState } from "react";

const DownloadCSVPopupHOC = (Component: any) =>
  function Comp(props: any) {
    const [showDownloadCSVPopup, setShowDownloadCSVPopup] = useState<boolean>(false);

    const downloadCSVPopupToggleHandler = () => {
      setShowDownloadCSVPopup(!showDownloadCSVPopup);
    };

    return (
      <Component
        showDownloadCSVPopup={showDownloadCSVPopup}
        downloadCSVPopupToggleHandler={downloadCSVPopupToggleHandler}
        {...props}
      />
    );
  };

export default DownloadCSVPopupHOC;
